<template>

  <b-row
    style="height: 80vh"
  >
    <b-col
      v-for="(analysis, index) in processedRequestsAnalysis"
      :key="index"
      cols="4"
    >
      <ChartTable
        :colors1="colors1[index % colors1.length]"
        :colors2="colors2[index % colors2.length]"
        :source="`${analysis.source}`"
        :requests-analysis=" analysisWithoutSource(index) "
        :have-animation="true"
      />
    </b-col>
  </b-row>
</template>

<script>
import ChartTable from '@/components/analysis-table/ChartTable.vue'
import { colors1, colors2 } from '@/components/analysis-table/colorsGradient'

export default {
  components: {
    ChartTable,
  },
  props: {
    requestsAnalysisData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      dashboard: {},
      requestsAnalysis: this.requestsAnalysisData,
      source: '',
      colors1,
      colors2,
    }
  },
  computed: {
    processedRequestsAnalysis() {
      if (!this.requestsAnalysis || !this.requestsAnalysis.length) return []

      return this.requestsAnalysis
    },
  },
  methods: {
    analysisWithoutSource(index) {
      const { source, ...analysisWithoutSource } = this.requestsAnalysis[index]
      return analysisWithoutSource
    },
  },
}
</script>
